import { Injectable } from "@angular/core";

import { GetPagedBody, HttpService, HttpServiceBaseCRUD, Product } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class ProductsService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "products/";
  }

  add(product: Product) {
    return this.post<Product>({ APIName: "add", body: product });
  }

  update(product: Product) {
    return this.put<Product>({ APIName: "update", body: product });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<Product>({ APIName: `get-id/${id}` });
  }

  getPaged(body: GetPagedBody<Partial<Product>>) {
    return this.getPagedRequest<Product[]>({ APIName: "getproductpaged", body });
  }

  getAll() {
    return this.get<Product[]>({ APIName: "getall" });
  }

  getProductsByTypeId(id: number) {
    return this.get<Product[]>({ APIName: `get-product-type/${id}` });
  }
}
